import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Calendar, Archive } from 'lucide-react';

interface ArchiveConfirmationModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  contactName?: string;
  actionCount: number;
}

export function ArchiveConfirmationModal({
  open,
  onOpenChange,
  onConfirm,
  contactName,
  actionCount
}: ArchiveConfirmationModalProps) {
  const archiveDate = new Date();
  const deleteDate = new Date(archiveDate.getTime() + 30 * 24 * 60 * 60 * 1000);

  const handleConfirm = () => {
    onConfirm();
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Archive className="h-5 w-5" />
            Archive Contact Actions
          </DialogTitle>
          <DialogDescription>
            You're about to archive all actions for {contactName || 'this contact'}.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          <div className="bg-muted/50 rounded-lg p-4 space-y-3">
            <div className="flex items-center justify-between">
              <span className="text-sm font-medium">Actions to archive:</span>
              <Badge variant="secondary">{actionCount}</Badge>
            </div>
            
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <Calendar className="h-4 w-4" />
              <span>Archived until: {deleteDate.toLocaleDateString()}</span>
            </div>
            
            <div className="text-xs text-muted-foreground">
              Archived actions will be moved to the Archive tab and automatically deleted after 30 days.
            </div>
          </div>

          <div className="flex gap-2 justify-end">
            <Button
              variant="outline"
              onClick={() => onOpenChange(false)}
            >
              Cancel
            </Button>
            <Button
              onClick={handleConfirm}
              className="gap-2"
            >
              <Archive className="h-4 w-4" />
              Archive Actions
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}